export const CHECKED = 'checked';
export const UNCHECKED = 'unchecked';
export const INDETERMINATE = 'indeterminate';
export const DISABLED = 'disabled';



// WEBPACK FOOTER //
// ./components/checkbox/constants.js